import i18n from "i18n";

const Messages = {
  Create: i18n.t('notifications.common.create', { dataType: i18n.t('labels.reportPresets') }),
  Update: i18n.t('notifications.common.update', { dataType: i18n.t('labels.reportPresets') }),
  Delete: i18n.t('notifications.common.delete', { dataType: i18n.t('labels.reportPresets') })
};

export default Messages;

i18n.on('languageChanged', () => {
  Messages.Create = i18n.t('notifications.common.create', { dataType: i18n.t('labels.reportPresets') });
  Messages.Update = i18n.t('notifications.common.update', { dataType: i18n.t('labels.reportPresets') });
  Messages.Delete = i18n.t('notifications.common.delete', { dataType: i18n.t('labels.reportPresets') });
})